import * as tslib_1 from "tslib";
import { ListenerCache } from '../../util/listenercache';
import { View } from '../view';
var EventManager = /** @class */ (function (_super) {
    tslib_1.__extends(EventManager, _super);
    function EventManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onInit = _this.createCache;
        _this.onBeforeUpdate = _this.attachEvents;
        return _this;
    }
    EventManager.prototype.createCache = function () {
        var _this = this;
        var object = this.attrs.object;
        this.events = new ListenerCache({
            add: function (key, listener) {
                var dissolve = object.addListener(key, listener);
                return function () { return google.maps.event.removeListener(dissolve); };
            },
            hit: function (key, event) {
                var _a = _this.attrs.on, on = _a === void 0 ? {} : _a;
                event.target = object;
                if (on && key in on)
                    on[key](event);
            }
        });
        this.attachEvents();
    };
    EventManager.prototype.attachEvents = function () {
        var _a = this.attrs.on, on = _a === void 0 ? {} : _a;
        this.events.attach(Object.keys(on));
    };
    EventManager.prototype.onRemove = function () {
        this.events.remove();
    };
    EventManager.prototype.render = function () {
        return this.children;
    };
    return EventManager;
}(View));
export { EventManager };
